/* eslint 'no-loop-func': 'off' */
import $ from 'jquery';
import _ from 'lodash';

import { LIMIT_LENGTH_TRANSLATE_PACK, BACK_SLASH_N, BACK_DOUBLE_SLASH_N, SPLIT_SYMBOL_REGEXP, PARAGRAPH_MARK_SYMBOL, GOOGLE_PARAGRAPH_MARK_SYMBOL } from '@/constants';
const LANG_EN = 'en';
const LANGS_PDF = [LANG_EN, 'cn', 'de', 'jp', 'tw'];

export const getBlankPdfByLang = (lang, isNoPermission) => {
    const bUrl = window.STATIC_COMMON_URL;
    if (bUrl) {
        const language = _.includes(LANGS_PDF, lang) ? lang : LANG_EN;
        const pdfLink = `${bUrl}/view/${isNoPermission ? 'no_permission' : 'no'}_${language}.pdf`;
        return pdfLink.replace('//view/', '/view/');
    }
    return '';
};

// http://git.patsnap.com/core-product/frontend/analytics-website/merge_requests/8098#note_159644
const parser = new DOMParser();
export const transformByHtmlInnerText = (html = '') => {
    const parsedHtml = parser.parseFromString(`<div>${html}</div>`, 'text/html');
    return parsedHtml.body.innerText;
};

/* 将html文案按照段落分割 */
export const transformByHtmlTextSplitList = (html = '') => {
    const parsedHtml = parser.parseFromString(`<div id="virtual-tree">${html}</div>`, 'text/html');
    let divList = parsedHtml.querySelectorAll('div[p]');
    // 如果没有div[p]标记的段落，则直接取整篇数据
    if (!divList.length) {
        divList = parsedHtml.querySelectorAll('#virtual-tree');
    }
    // 标题可能没有段落区分
    const sectionTextList = [];
    Array.from(divList).forEach(node => {
        sectionTextList.push(node.innerText);
    });
    return sectionTextList;
};

/* 根据段落分割文本 */
export const TextSlicerByParagraph = ({ separatorReg = SPLIT_SYMBOL_REGEXP, maxLength = LIMIT_LENGTH_TRANSLATE_PACK, contentList, isAiPatent }) => {
    // 分片结果
    const pieces = [];
    // 当前片所包含的段落，数组中每一项为原始文本的一段
    let curPiecesParaList = [];
    // 当前片的长度
    let curPiecesLength = 0;

    // 分片
    const pickPiece = () => {
        // PARAGRAPH_MARK_SYMBOL作为唯一标识符，用来还原翻译之后的段落
        const markSymbol = isAiPatent ? PARAGRAPH_MARK_SYMBOL : GOOGLE_PARAGRAPH_MARK_SYMBOL;
        const piece = curPiecesParaList.join(markSymbol);
        pieces.push([piece]);
        // reset
        curPiecesParaList = [];
        curPiecesLength = 0;
    };

    // 记录当前片的信息
    const tottingUpPara = (paraLength, paragraph) => {
        curPiecesLength += paraLength;
        curPiecesParaList.push(paragraph);
    };

    //分割当前段落
    const splitParagraph = (para) => {
        const paragraph = [];
        while (para.length > 0) {
            let maxLengthStr = para.substring(0, LIMIT_LENGTH_TRANSLATE_PACK);

            // 字符串反转,然后正则匹配到最后一个需要截断文本的符号
            maxLengthStr = maxLengthStr.split('').reverse().join('');

            const matchSymbol = _.get(maxLengthStr.match(separatorReg), '0');
            if (!matchSymbol) {
                paragraph.push(maxLengthStr);
                para = para.substring(LIMIT_LENGTH_TRANSLATE_PACK + 1);
            } else {
                maxLengthStr = maxLengthStr.split('').reverse().join('');
                const lastIndex = maxLengthStr.lastIndexOf(matchSymbol);
                // 二次分割完整的句子
                paragraph.push(maxLengthStr.substring(0, lastIndex + 1));
                para = para.substring(lastIndex + 1);
            }

        }
        if (paragraph.length > 0) pieces.push(paragraph);
    };


    for (let i = 0; i < contentList.length; i++) {
        const paragraph = contentList[i];
        const paraLength = paragraph.length;

        if (curPiecesLength > 0) {
            // 如果当前片有本文，并且加上当前段落超出最大长度，则当前片固定
            if (curPiecesLength + paraLength > maxLength) {
                pickPiece();
                if (paraLength > maxLength) {
                    /* 段内分片逻辑 */
                    splitParagraph(paragraph);
                } else {
                    tottingUpPara(paraLength, paragraph);
                }
            } else {
                tottingUpPara(paraLength, paragraph);
            }
        }

        if (curPiecesLength === 0) {
            // 如果当前段为一片的开始，且小于最大长度，则直接放入
            if (paraLength < maxLength) {
                tottingUpPara(paraLength, paragraph);
            } else {
                /* 段内分片逻辑 */
                splitParagraph(paragraph);
            }
        }
        // 最后一段文本
        if (i === contentList.length - 1 && curPiecesLength !== 0) {
            pickPiece();
        }
    }

    return pieces;
};

/**
 *  文本分割
 *  根据换行符和最大长度
 */
export const TextSlicer = ({ separator = BACK_SLASH_N, maxlength = LIMIT_LENGTH_TRANSLATE_PACK } = {}) => (
    content = '',
) => {
    const _overflow = length => {
        return length > maxlength;
    };

    const paragraphs = content.split(separator);
    const pieces = [];
    let bundle = [];

    const _sizeOfPack = () => {
        return bundle.join().length;
    };

    // 打包
    const _pack = () => {
        console.log(
            `origin text size is ${content.length}, this bundle has ${
                bundle.length
            } paragraph, total size is ${_sizeOfPack()}`,
        );
        pieces.push(bundle.join(BACK_DOUBLE_SLASH_N));
        bundle = [];
    };

    /**
     * 分割大文本
     * FIXME: 现在是按长度来分割的，为了语义的准确，应从标点符号处分割。
     */
    const _splitLongText = paragraph => {
        const sizeOfPack = _sizeOfPack();
        const sizeOfPackRemaining = maxlength - sizeOfPack;
        bundle.push(paragraph.slice(0, sizeOfPackRemaining));
        _pack();
        _.chunk(paragraph.slice(sizeOfPackRemaining), maxlength).forEach(subParagraph => {
            bundle.push(subParagraph.join(''));
            if (subParagraph.length === maxlength) {
                _pack();
            }
        });
    };

    for (let i = 0, size = paragraphs.length; i < size; i++) {
        const paragraph = _.trim(paragraphs[i]);
        if (!paragraph) continue;
        const fn = paragraph => {
            const sizeOfParagraph = paragraph.length;
            if (_overflow(sizeOfParagraph)) {
                _splitLongText(paragraph);
            } else {
                if (_overflow(_sizeOfPack() + sizeOfParagraph)) {
                    _pack();
                }
                bundle.push(paragraph);
            }
        };
        fn(paragraph);
    }

    if (bundle.length > 0) {
        _pack();
    }
    return pieces;
};

export const getObjectBylang = (obj, lang) => {
    if (!obj) return '';

    const keys = Object.keys(obj);

    if (keys.length > 0) {
        if (obj[lang]) {
            return obj[lang];
        }
        return obj[keys[0]];

    }
    return '';
};

export const recoverHtmlBrackets = str => {
    if (str.indexOf('&lt;math&gt;') >= 0) {
        return str
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&nbsp;/g, ' ');
    }
    return str;
};

export function downloadFileByIframe(url) {
    // 创建隐藏的iframe来下载PDF
    let $iframe = $('<iframe>');
    $iframe
        .hide()
        .attr('src', url)
        .appendTo(document.body);
    // Firefox会触发load事件，但是如果此时删除iframe，文件将不会被下载
    // Chrome不会触发load事件
    // 由于以上情况，现在改为1分钟以后删除iframe
    setTimeout(function() {
        $iframe.remove();
        $iframe = null;
    }, 60 * 1000);
}

export const ensure = m => (m.default ? m.default : m);

export async function loop(retryFn, interval, successFn) {
    let timeoutFn;
    let res;
    return new Promise((resolve) => {
        const retryFnWrap = async () => {
            res = await retryFn();

            if (successFn(res)) {
                resolve(res);
                return;
            }
            // 超时处理
            if (timeoutFn) {
                clearTimeout(timeoutFn);
            }

            timeoutFn = setTimeout(() => {
                retryFnWrap();
            }, interval);
        };
        retryFnWrap();
    });
}

export const isValidUrl = str => {
    const regexp = /(^(http|https):\/\/.*)|(^\/\/.*)/;
    return regexp.test(str);
};


/**
 * 乘法精度问题
 * @param a
 * @param b
 * @returns {number}
 */
export function mul(a, b) {
    let c = 0;
    const d = a.toString();
    const e = b.toString();
    try {
        c += d.split('.')[1].length;
        // eslint-disable-next-line no-empty
    } catch (f) {}
    try {
        c += e.split('.')[1].length;
        // eslint-disable-next-line no-empty
    } catch (f) {}
    return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / 10 ** c;
}


export const strSliceForTitle = (inputStr, num, simbol) => {
    function subStr(s, slicer) {
        s = String(s);
        slicer = slicer || [0, 10];
        return s.slice(slicer[0], slicer[1]);
    }

    simbol = simbol || '...';

    let res = inputStr;
    if ((typeof res === 'string') && (res.length > num)) {
        res = subStr(res, [0, num - simbol.length]) + simbol;
    }
    return res;
};


/*
* 生成随机字符串ID
*/
export const generateUniqueId = (length = 16) => {
    let id = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
        id += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return id;
};

/**
 * 格式化数组显示
 * 如果数组为空，显示 "-"
 * 如果数组只有一个元素，显示该元素
 * 如果数组有多个元素，显示第一个元素 + "+数量"
 * @param {Array|string} data - 要处理的数据，可以是数组或字符串
 * @param {string} separator - 分隔符，默认为 ', '
 * @param {string} emptyPlaceholder - 空值占位符，默认为 '-'
 * @returns {string} 格式化后的字符串
 */
export const formatArrayDisplay = (data, separator = ', ', emptyPlaceholder = '-') => {
    // 如果是字符串，按分隔符分割成数组
    let array = data;
    if (typeof data === 'string') {
        array = data.split(separator).map(item => item.trim()).filter(Boolean);
    }
    
    // 如果不是数组或为空，返回占位符
    if (!Array.isArray(array) || array.length === 0) {
        return emptyPlaceholder;
    }
    
    // 如果只有一个元素，直接返回
    if (array.length === 1) {
        return String(array[0]);
    }
    
    // 如果有多个元素，返回第一个 + "+数量"
    return `${array[0]}+${array.length - 1}`;
};
